import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {config} from '../../shared/config';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {RecurringReport} from '../models/recurring-report';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class RecurringReportsService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  getRecurringReports(): Observable<RecurringReport[]> {
    return this.get(config.generateApiUrl('RecurringReports', null, null) + `?take=100`).pipe(
      map(data => data['recurringReports'] as RecurringReport[])
    );
  }

  createRecurringReports(recurringReport: RecurringReport): Observable<RecurringReport> {
    recurringReport.id = null;
    return this._http.post(config.generateApiUrl('RecurringReports', null, null), recurringReport).pipe(
      map(data => data as RecurringReport)
    );
  }

  deleteRecurringReports(id: number): Observable<any> {
    return this._http.delete(config.generateApiUrl('RecurringReports', null, null) + `/${id}`);
  }
}
